import { getReviewsFromState } from '../selectors/reviews';

import { useAppSelector } from './redux';

export const useReviews = () => useAppSelector(getReviewsFromState);
